<template>
  <b-form-group :label="label" :label-class="required ? 'required' : ''">
    <b-form-input
      :required="required ? 'required' : ''"
      v-model="internalValue"
      :placeholder="placeholder ? placeholder : `${label} را وارد نمایید`"
    ></b-form-input>
    <b-form-invalid-feedback id="input-1-live-feedback">
      {{ label }} ضروری است
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: "Input",
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: null
    },

    required: {
      type: Boolean,
      default: false
    }
  }
};
</script>
